/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
type Scope = unknown;
type Factory = () => any;

type Container = {
    init(shareScope: Scope): void;
    get(module: string): Factory;
};

export type TRemoteOptions = {
    remoteName: string;
    remoteEntry: string;
    exposedModule: string;
};

declare const __webpack_init_sharing__: (shareScope: string) => Promise<void>;
declare const __webpack_share_scopes__: { default: Scope };

let isDefaultScopeInitialized = false;
const remoteMap: Record<string, boolean> = {};
const moduleMap: Record<string, boolean> = {};

declare global {
    interface Window {
        process: any;
        require: any;
        init: any;
        get: any;
    }
}

async function lookupExposedModule<T>(remoteName: string, exposedModule: string, remoteEntry: string): Promise<T> {
    try {
        const container = window[remoteName as any] as Container;
        const factory = await container.get(exposedModule);
        const Module = factory();
        return Module as T;
    } catch (error) {
        console.error(
            `MODULE FEDERATION: Not found ${exposedModule}.
             Obs: Verifique se o expose: ${exposedModule} (Modulo ou Component) 
             que deseja consumir e está disponível para consumo no scope (${remoteName}) na url ${remoteEntry}`,
        );
        return Promise.reject(error);
    }
}

async function initRemote(remoteName: string) {
    try {
        const container = window[remoteName as any] as Container;

        // verifica se existe o remoteName (scope) carregado no window
        if (!container)
            throw new Error(
                `MODULE FEDERATION: Não foi encontrado o scope ${remoteName} exportado no remoteEntry.js, verifique se está correto o nome do scope (${remoteName}) tanto na plataforma quanto no modulo exportado`,
            );

        // verifica se existe o remoteName
        if (remoteMap[remoteName]) return container;

        // verifica se scope default ja foi inicializado
        if (!isDefaultScopeInitialized) {
            // Inicializa o escopo compartilhado. Preenche-o com os módulos fornecidos conhecidos desta construção e todos os controles remotos
            await __webpack_init_sharing__('default');
            isDefaultScopeInitialized = true;
        }

        // carrega scope default do window
        await container.init(__webpack_share_scopes__.default);

        // adiciona o remoteName no objeto
        remoteMap[remoteName] = true;
        return container;
    } catch (err) {
        console.error(err);
    }
}

function loadRemoteEntry(remoteEntry: string, remoteName: string) {
    return new Promise<void>((resolve, reject) => {
        if (moduleMap[remoteEntry]) {
            resolve();
            return;
        }

        const script = document.createElement('script');
        script.src = remoteEntry;
        script.onerror = () => {
            // Verifique se o nome do scope (${remoteName}) está correto na plataforma e modulo exportado.
            console.error(
                `MODULE FEDERATION: Not found ${remoteName}: obs: Verifique se o remoteEntry.js foi exportado corretamente e está disponível para consumo na url: ${remoteEntry}`,
            );
            reject();
        };

        script.onload = () => {
            initRemote(remoteName);
            moduleMap[remoteEntry] = true;
            resolve();
        };

        document.body.appendChild(script);
    });
}

async function loadRemoteModule<T = any>(options: TRemoteOptions): Promise<T> {
    if (options.remoteEntry) {
        await loadRemoteEntry(options.remoteEntry, options.remoteName);
    }
    return lookupExposedModule<T>(options.remoteName, options.exposedModule, options.remoteEntry);
}

export default loadRemoteModule;
